/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskWorkflowItemConfigurationTargeting } from './TaskWorkflowItemConfigurationTargeting';
import {
    TaskWorkflowItemConfigurationTargetingFromJSON,
    TaskWorkflowItemConfigurationTargetingFromJSONTyped,
    TaskWorkflowItemConfigurationTargetingToJSON,
    TaskWorkflowItemConfigurationTargetingToJSONTyped,
} from './TaskWorkflowItemConfigurationTargeting';

/**
 * 
 * @export
 * @interface UpdateTaskWorkflowItemConfigurationRequest
 */
export interface UpdateTaskWorkflowItemConfigurationRequest {
    /**
     * Null clears the override so a master item uses its master name. Custom organization items require a name.
     */
    display_name_override?: string | null;
    /**
     * 
     */
    targeting?: TaskWorkflowItemConfigurationTargeting;
}

/**
 * Check if a given object implements the UpdateTaskWorkflowItemConfigurationRequest interface.
 */
export function instanceOfUpdateTaskWorkflowItemConfigurationRequest(value: object): value is UpdateTaskWorkflowItemConfigurationRequest {
    return true;
}

export function UpdateTaskWorkflowItemConfigurationRequestFromJSON(json: any): UpdateTaskWorkflowItemConfigurationRequest {
    return UpdateTaskWorkflowItemConfigurationRequestFromJSONTyped(json, false);
}

export function UpdateTaskWorkflowItemConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTaskWorkflowItemConfigurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'display_name_override': json['display_name_override'] === undefined ? undefined : json['display_name_override'] === null ? null : json['display_name_override'],
        'targeting': json['targeting'] == null ? undefined : TaskWorkflowItemConfigurationTargetingFromJSON(json['targeting']),
    };
}

export function UpdateTaskWorkflowItemConfigurationRequestToJSON(json: any): UpdateTaskWorkflowItemConfigurationRequest {
    return UpdateTaskWorkflowItemConfigurationRequestToJSONTyped(json, false);
}

export function UpdateTaskWorkflowItemConfigurationRequestToJSONTyped(value?: UpdateTaskWorkflowItemConfigurationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'display_name_override': value['display_name_override'],
        'targeting': TaskWorkflowItemConfigurationTargetingToJSON(value['targeting']),
    };
}

